import * as React from 'react';

var IntentContext = /*#__PURE__*/React.createContext({
  intent: 'generic'
});
var IntentContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(IntentContext.Provider, {
    value: value
  }, children);
});
IntentContextProvider.displayName = 'IntentContextProvider';

export { IntentContext, IntentContextProvider };
//# sourceMappingURL=Intent.js.map
